import React from "react";
import {Card} from "react-bootstrap";
import InstrumentBTKTable from "./InstrumentBTKTable";
import StringInput from "../../../formElements/StringInput";
import WorkList from "../../../tableLists/WorkList";
import SparePartList from "../../../tableLists/SparePartList";
import RichTextInput from "../../../formElements/RichTextInput";
import FormContext from "../../../support/FormContext";


function SingleInstrumentSectionBTK(props) {

    const {isSectionAdded} = React.useContext(FormContext)
    const [showDetails, setShowDetails] = React.useState(isSectionAdded)

    function unpackSection() {
        setShowDetails(!showDetails)
    }

    return (
        <div className="mb-3">
            <Card border={"muted"} bg={"light"}>
                <div className="m-lg-3">
                    <InstrumentBTKTable empty={false} unpackSection={unpackSection}
                                        selectInstrument={props.selectInstrument}
                                        instrument={props.item}
                                        instrumentIndex={props.ndx}
                                        data={props.data}
                                        deleteInstrument={props.deleteInstrument}
                                        selectBTKResult={props.selectBTKResult}
                                        unpackable={true}
                    />
                    {showDetails && (
                        <>
                            <RichTextInput name={`Pristroje.${props.ndx}.Stav_Nedostatky`} label={'Stav/Nedostatky'}
                                           value={props.item.Stav_Nedostatky}
                                           onChange={props.update}/>
                            <RichTextInput name={`Pristroje.${props.ndx}.Vykonane_Prace`} label={'Vykonané Práce'}
                                           value={props.item.Vykonane_Prace} onChange={props.update}/>
                            <WorkList delete={props.deleteWork} select={props.selectWork} update={props.updateWork}
                                      ndx={props.ndx} data={props.data}/>
                            <SparePartList delete={props.deletePart} select={props.selectPart}
                                           update={props.updatePart} ndx={props.ndx} data={props.data} form={"btk"}/>
                            <StringInput name={`Pristroje.${props.ndx}.Poznamka`} label={'Poznámka'}
                                         value={props.item.Poznamka}
                                         onChange={props.update}/>
                        </>
                    )}
                </div>
            </Card>
        </div>
    )
}

export default SingleInstrumentSectionBTK
